import { CreateHouseWalletInterface } from "../interfaces/HouseWalletInterfaces/CreateHouseWalletInterface";
import { HouseWalletInterface } from "../interfaces/HouseWalletInterfaces/HouseWalletInterface";
import BaseService from "./BaseService";

export class HouseWalletService extends BaseService<HouseWalletInterface, CreateHouseWalletInterface>{ 
    constructor(){
        let url: string = '/house-wallet/admin'
        super(url)
    }
}